/// <amd-module name="Artifacts/PackageRecycleBin/redux/Module" />

import { IPackageRecycleBinState } from "Artifacts/PackageRecycleBin/redux/Contracts";
import { packageRecycleBinReducer } from "Artifacts/PackageRecycleBin/redux/Reducer";
import { rootSaga } from "Artifacts/PackageRecycleBin/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { VSSPageDataModule } from "VSS/Redux/Modules/VSSPageData";

export interface IPackageRecycleBinModuleState {
  packageRecycleBinState: IPackageRecycleBinState;
}

const _packageRecycleBinReduxModule: ISagaModule<IPackageRecycleBinModuleState> = {
  id: "package-recycle-bin",
  reducerMap: {
    packageRecycleBinState: packageRecycleBinReducer,
  },
  sagas: [rootSaga],
};

export const PackageRecycleBinReduxModule = [VSSPageDataModule, _packageRecycleBinReduxModule];
